<template>
    <div>
      <EditMessageTemplate
          v-if="id"
          page_title="テンプレート編集" :id="id" :isSubmitting="isSubmitting"
          @custom:submit="submitHandler"/>
      <EditMessageTemplate
          v-else
          page_title="テンプレート新規追加"
          @custom:submit="submitHandler"
          :isSubmitting="isSubmitting"
          />
    </div>
  </template>
  
  <script>
  import EditMessageTemplate from "./EditMessageTemplate.vue";
  import { mapActions, mapGetters } from "vuex";
  import ApiService from "@/service/apiService";
  import API from "@/config/api";
  
  export default {
    name: "ModifyMessageTemplate",
    components: { EditMessageTemplate },
    props: ["id"],
    data() {
      return {
        errors: [],
        isSubmitting: false,
      }
    },
    computed: {
      ...mapGetters({currentUser: 'getCurrentUser'}),
      hasContactAuthority(){
        return this.currentUser && (this.currentUser.companyContactAuthority);
      }
    },
    methods: {
      ...mapActions([
        "removeAllFlashMessages",
        "loadAllMessageTemplates",
        "addFlashMessages"
      ]),
      async submitHandler(payload) {
        try {
          this.isSubmitting = true;
          let res;
          if (this.id) {
            res = await ApiService.put(API.endpoints.EDIT_MESSAGE_TEMPLATE(payload.id), payload);
          } else {
            res = await ApiService.post(API.endpoints.ADD_MESSAGE_TEMPLATE, payload);
          }
          await this.loadAllMessageTemplates();
          await this.$router.push({name: "message-template"});
          this.addFlashMessages([{message: res.data.data.success, type: "success"}]);
          setTimeout(() => {
            this.removeAllFlashMessages();
          }, 5000);
          this.isSubmitting = false;
        } catch (err) {
          this.isSubmitting = false;
          this.errors = [];
          let messages = [];
  
          this.parseErrorResponse(err.response);
          let error = this.errors[0];
          for (let key of Object.keys(error)) {
            messages.push({message: error[key].msg, type: "danger"});
          }
  
          this.addFlashMessages([...messages]);
          setTimeout(() => {
            this.removeAllFlashMessages();
          }, 5000);
        }
      }
    },
    watch: {
        currentUser(newVal){
            if(newVal !== null) {
                if(!this.hasContactAuthority) {
                    return this.$router.push('/applicant');
                }
            }
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>